/*
 * @Author: wsx
 * @Date: 2022-01-19 09:28:58
 * @LastEditTime: 2022-06-13 16:31:12
 * @LastEditors: zhangyaowen zhangyaowen_520@163.com
 * @Description:
 */
import request from "@/utils/request.js";
// 房屋信息
export const getHouseList = data => {
  return request({
    url: "/apiData/hz-data-community/daas/fwxx/info",
    params: data || {}
  });
};

// 获取房屋管理列表
export const queryUserList = data => {
  return request({
    url: "/api/hz-smart-community/house/info/list",
    params: data || {}
  });
};

// 保存房屋管理
export const saveQuery = data => {
  return request({
    url: "/api/hz-smart-community/house/info/save",
    data: data || {},
    method: "POST"
  });
};

// 修改房屋管理
export const updateQuery = data => {
  return request({
    url: "/api/hz-smart-community/house/info/update",
    data: data || {},
    method: "POST"
  });
};

// 删除房屋管理
export const deleteQuery = data => {
  return request({
    url: "/api/hz-smart-community/house/info/delete",
    data: data || {},
    method: "POST"
  });
};

// 信息
export const infoQuery = data => {
  return request({
    url: "/api/hz-smart-community/house/info/info/" + data,
    params: data || {}
  });
};

// 物业人员管理列表
export const propertyList = data => {
  return request({
    url: "/api/hz-smart-community/property/info/list",
    params: data || {}
  });
};
// 物业人员信息

export const propertyinfoinfo = data => {
  return request({
    url: "/api/hz-smart-community/property/info/info/" + data,
    params: data || {}
  });
};
// 小区
export const regionselect = data => {
  return request({
    url: "/api/hz-smart-community/region/info/select",
    params: data || {}
  });
};
// 删除
export const regioninfoinfo = data => {
  return request({
    url: `/api/hz-smart-community/region/info/info/${data}`,
    params: data || {}
  });
};
// 物业人员保存
export const propertysave = data => {
  return request({
    url: "/api/hz-smart-community/property/info/save",
    data: data || {},
    method: "POST"
  });
};

// 物业人员修改
export const propertyupdate = data => {
  return request({
    url: "/api/hz-smart-community/property/info/update",
    data: data || {},
    method: "POST"
  });
};
// 物业人员删除
export const propertydelete = data => {
  return request({
    url: "/api/hz-smart-community/property/info/delete",
    data: data || {},
    method: "POST"
  });
};

// 车辆人员列表
export const carlist = data => {
  return request({
    url: "/api/hz-smart-community/car/info/list",
    params: data || {}
  });
};
// 车辆人员删除
export const cardelete = data => {
  return request({
    url: "/api/hz-smart-community/car/info/delete",
    data: data || {},
    method: "POST"
  });
};
// 车辆人员添加
export const carsave = data => {
  return request({
    url: "/api/hz-smart-community/car/info/save",
    data: data || {},
    method: "POST"
  });
};
// 车辆人员修改
export const carupdate = data => {
  return request({
    url: "/api/hz-smart-community/car/info/update",
    data: data || {},
    method: "POST"
  });
};

// 车辆人员详情
export const carinfo = data => {
  return request({
    url: "/api/hz-smart-community/car/info/info/" + data,
    params: data || {}
  });
};

// 车辆人员详情
export const prisonlist = data => {
  return request({
    url: "/api/hz-smart-community/house/prison/log/list",
    data: data || {},
    method: "post"
  });
};
// 车辆人员详情
export const eventlist = data => {
  return request({
    url: "/api/hz-smart-community/event/list",
    data: data || {},
    method: "post"
  });
};